import * as Sentry from '@sentry/vue';

const config_sentry = (vue_app, vue_router) => {
  if (!import.meta.env.VITE_SENTRY_DSN) return;

  Sentry.init({
    app: vue_app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({
        router: vue_router,
      }),
      //   Sentry.replayIntegration({
      //     networkCaptureBodies: true,
      //     networkDetailAllowUrls: [
      //       /^https:\/\/api\.amadast\.com(\/.*)?$/,
      //       /^https:\/\/staging-api\.amadast\.com(\/.*)?$/,
      //     ],
      //     maskAllText: false,
      //     maskAllInputs: false,
      //   }),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/taminify\.com/],
    // replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
  });
};

const set_sentry_user = (hash_id, username = null) => {
  if (!import.meta.env.VITE_SENTRY_DSN) return;

  Sentry.setUser({
    id: hash_id,
    username: username,
  });
};

const unset_sentry_user = () => {
  if (!import.meta.env.VITE_SENTRY_DSN) return;

  Sentry.setUser(null);
};

export { config_sentry, set_sentry_user, unset_sentry_user };
